import { Logger } from "../Logger";
import { NewformaApiClient } from "./NewformaApiClient";
import { HttpRequestWrapper } from "../HttpRequestWrapper";
import { Request } from "../Request";
import { IHub } from "../../models/Hub";
import { Email } from "@newforma/platform-client-api-sdk";

export class UserEmailSettingsApiService {
    private readonly url: string = "/v1/emails/settings";

    private getBaseUrl(hub: IHub): string {
        return this.newformaApiClient.mapDomainRegion(hub);
    }

    constructor(
        private readonly _logger: Logger,
        private readonly newformaApiClient: NewformaApiClient,
        private readonly requestWrapper: HttpRequestWrapper
    ) {}

    async saveSettings(selectedHub: IHub, body: Partial<Email.UserEmailSettings>): Promise<void> {
        const request: Request = {
            url: `${this.getBaseUrl(selectedHub)}${this.url}`,
            method: "PATCH",
            body: JSON.stringify(body),
            headers: {
                "x-newforma-agent": this.newformaApiClient.getNewformaAgent(),
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        };

        return this.newformaApiClient.makeRequest(request, (signedRequest) =>
            this.requestWrapper.patch(signedRequest.url, undefined, signedRequest.headers, request.body)
        );
    }

    async getSettings(selectedHub: IHub): Promise<Email.UserEmailSettings> {
        const request: Request = {
            url: `${this.getBaseUrl(selectedHub)}${this.url}`,
            method: "GET",
            headers: {
                "x-newforma-agent": this.newformaApiClient.getNewformaAgent(),
            },
        };

        return this.newformaApiClient.makeRequest(request, (signedRequest) =>
            this.requestWrapper.get(signedRequest.url, undefined, signedRequest.headers)
        );
    }
}
